/**
 * 
 * Date Picker Box
 * 
 */

import React from 'react';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';

class DatePickerBox extends React.Component {

    render() {
        const { name, label, value, placeholder, fieldStatus, onInputChange, defaultValue, disabled, enablePastDate, view, dateFormat } = this.props;
        const display = fieldStatus && fieldStatus === "Display Only";
        return (<div className="p-col-12">
            {!display ?
                <label className="label">
                    {label}
                    {/* <span className="requiredColor">*</span> */}
                </label> : null}
            <div className={display ? "mt3" : "mt1"}>
                {display ?
                    <div> {label}: {value || defaultValue}</div> :
                    <Calendar
                        placeholder={placeholder}
                        value={value && new Date(moment.utc(value)) || ''}
                        name={name}
                        disabled={disabled}
                        onChange={onInputChange}
                        style={{width: '100%'}}
                        readOnlyInput={true}
                        view={view}
                        yearNavigator={view === 'month' ? true : false}
                        yearRange={view === 'month' ? "2020:2050" : undefined}
                        dateFormat={dateFormat}
                        //minDate={!enablePastDate && new Date() || false}
                        showIcon={true} />
                }
            </div>
        </div>)
    }
}


export default DatePickerBox;